export const REQUEST_PATIENTS = "list-patients";
export const SEARCH_REQUEST_PATIENTS = "search-patients";
export const REQUEST_PROFIL_PATIENT = "profil-patient";
export const REQUEST_CONSULTATIONS_PATIENT = "profil-consultations";
export const PATIENTS_LOADED = "loaded-patients";

export const UPDATE_PATIENT = "update-patient";
export const UPDATED_PATIENT = "updated-patient";

export function requestPatients()
{
    return {
        type: REQUEST_PATIENTS,
    };
}

export function searchPatients(payload)
{
    return {
        type: SEARCH_REQUEST_PATIENTS,
        data: payload
    };
}

export function requestProfilPatient(payload)
{
    return {
        type: REQUEST_PROFIL_PATIENT,
        payload: payload
    }
}

export function requestConsultationsPatient(payload)
{
    return {
        type: REQUEST_CONSULTATIONS_PATIENT,
        payload: payload
    }
}

export function loadedPatients(payload)
{
    return {
        type: PATIENTS_LOADED,
        payload: payload
    };
}

export function updatePatientData(payload) {
    return {
        type: UPDATE_PATIENT,
        id: payload.id,
        data: payload
    };
}

export function updatedPatient() {
    return {
        type: UPDATED_PATIENT
    };
}



// WEBPACK FOOTER //
// ./src/actions/patients.action.js